<template>
  <div ref="container" :class="componentClassName" hidden>
    <slot></slot>
  </div>
  <!-- eslint-disable -->
  <div v-html="content"></div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { ref } from 'vue';

export default {
  name: 'a-find-in-page-content',
  components: {},
  props: {
    class: {
      type: String,
      default: '',
    },
    modelValue: {
      // 1-1: v-model を使えるようにする
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      container: ref(null),
    };
  },
  data() {
    return {
      delimiter: '___FIND_IN_PAGE___', // 区切り文字
      contentParts: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-find-in-page-content');
      return `${baseClassName} ${this.class}`.trim();
    },
    content() {
      // 1-3: 表示するコンテンツを作成する（ハイライトする）

      const keyword = this.modelValue;
      return this.contentParts
        .map(contentPart => {
          let value = contentPart.value;

          if (keyword !== '') {
            const type = contentPart.type;

            if (type === 'text' && value.includes(keyword)) {
              // 通常のテキストでキーワードを含む場合

              const highlight = `<span class="a-find-in-page-content-highlight">${keyword}</span>`;
              value = value.replace(keyword, highlight);
            }
          }
          return value;
        })
        .join('');
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.parseContents();
  },
  methods: {
    parseContents() {
      // 1-2: タグ内にセットされたHTMLコンテンツを分類（タグ＆テキスト）して配列にする

      this.contentParts = [];
      const content = this.container.innerHTML.replace(/[<>]/g, match => {
        return match === '<' ? this.delimiter + '<' : '>' + this.delimiter;
      });
      const contents = content.split(this.delimiter);
      contents.forEach(contentPart => {
        if (contentPart !== '') {
          // id要素を重複させないようにするためidを置き換える
          if (contentPart.indexOf('id="detail_') === -1) {
            contentPart = contentPart.replaceAll('id="', 'id="detail_');
          }

          const type = contentPart.startsWith('<') // コンテンツの種類
            ? 'tag'
            : 'text';
          this.contentParts.push({
            type: type,
            value: contentPart,
          });
        }
      });
    },
  },
};
</script>
